import { render, staticRenderFns } from "./CafeteriaViewWarehouseProducts.vue?vue&type=template&id=22d87b3c"
import script from "./CafeteriaViewWarehouseProducts.vue?vue&type=script&lang=js"
export * from "./CafeteriaViewWarehouseProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports